import { EnvironmentConfig } from './environment.types';

export const environmentConfig: EnvironmentConfig = {
  API_URL: process.env.REACT_APP_API_URL || '',
  AUTH_API_URL: process.env.REACT_APP_AUTH_URL || '',
  APPSYNC_URL: process.env.REACT_APP_APPSYNC_URL || '',
  APPSYNC_API_KEY: process.env.REACT_APP_APPSYNC_API_KEY || '',
  ENV: (process.env.REACT_APP_ENV as 'development' | 'staging' | 'production') || 'development',
};
